import type { HttpResponse } from ".."
import { get } from "../../services/HttpService"
import {
  getMap,
  getMapListByChapter,
  getMapListByRegion,
  getMapListByTheme,
  getRecentMaps
} from "../../services/MapService"
import { hasFailed } from "../../utils"
import type { MapDetailDto, MapDto } from "./../../models/models"
import type { AppThunkAction, AppThunkDispatch } from "./../app.types"
import type { MapAction, MapListAction } from "./map.types"

export const MAP_FETCH: string = "MAP_FETCH"
export const MAP_LOAD: string = "MAP_LOAD"
export const MAP_FETCH_LIST: string = "MAP_FETCH_LIST"
export const MAP_LOAD_LIST: string = "MAP_LOAD_LIST"
export const MAP_FETCH_BY_CHAPTER: string = "MAP_FETCH_BY_CHAPTER"
export const MAP_FETCH_BY_THEME: string = "MAP_FETCH_BY_THEME"
export const MAP_FETCH_BY_REGION: string = "MAP_FETCH_BY_REGION"
export const MAP_FETCH_ALL: string = "MAP_FETCH_ALL"

export function fetchMap(id: string): AppThunkAction<void, MapAction> {
  return async (dispatch: AppThunkDispatch<MapAction>) => {
    dispatch({ type: MAP_FETCH })

    const map: MapDetailDto = await getMap(id)

    dispatch(loadMap(map))
  }
}

export function loadMap(map: MapDetailDto): MapAction {
  return {
    type: MAP_LOAD,
    payload: map
  }
}

export function fetchRecentMaps(count: number): AppThunkAction<void, MapListAction> {
  return async (dispatch: AppThunkDispatch<MapListAction>) => {
    dispatch({ type: MAP_FETCH_LIST })

    const maps: MapDto[] = await getRecentMaps(count)

    dispatch(loadMapList(maps))
  }
}

export function fetchMapList(subRegionId: string): AppThunkAction<void, MapListAction> {
  return async (dispatch: AppThunkDispatch<MapListAction>) => {
    dispatch({ type: MAP_FETCH_LIST })

    const response: HttpResponse<MapDto[]> = await get<MapDto[]>("map", `subregions/${subRegionId}/maps`)

    const maps: MapDto[] = hasFailed(response, true) ? [] : response.data!

    dispatch(loadMapList(maps))
  }
}

export function mapFetchByChapter(chapterId: string): AppThunkAction<void, MapListAction> {
  return async (dispatch: AppThunkDispatch<MapListAction>) => {
    dispatch({ type: MAP_FETCH_BY_CHAPTER })

    const maps: MapDto[] = await getMapListByChapter(chapterId)

    dispatch(loadMapList(maps))
  }
}

export function mapFetchByRegion(regionId: string): AppThunkAction<void, MapListAction> {
  return async (dispatch: AppThunkDispatch<MapListAction>) => {
    dispatch({ type: MAP_FETCH_BY_REGION })

    const maps: MapDto[] = await getMapListByRegion(regionId)

    dispatch(loadMapList(maps))
  }
}

export function mapFetchByTheme(themeId: string): AppThunkAction<void, MapListAction> {
  return async (dispatch: AppThunkDispatch<MapListAction>) => {
    dispatch({ type: MAP_FETCH_BY_THEME })

    const maps: MapDto[] = await getMapListByTheme(themeId)

    dispatch(loadMapList(maps))
  }
}

export function loadMapList(maps: MapDto[]): MapListAction {
  return {
    type: MAP_LOAD_LIST,
    payload: maps
  }
}
